import { XhrFactory } from '@angular/common';
import { HttpBackend, HttpClient, HttpHandler, HttpXhrBackend } from '@angular/common/http';
import { Injector } from '@angular/core';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { RecruiteeAuthStrategy } from 'apps/recruitee/recruitee-auth-strategy';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Providers, WebAppBootstrap } from 'apps/recruitee/src/bootstrap';
import moment from 'moment-timezone';

import {
  APP_CONFIG,
  AUTH_TOKEN,
  CommonEnvironment,
  ENVIRONMENT,
  IAppConfig,
} from '@recruitee/common';
import {
  AuthHelpers,
  AuthorisationStrategy,
  AuthService,
  CookieService,
  GenericAuthService,
} from '@recruitee/http';
import { LANGUAGE_CONFIG, LanguageConfig, patchMoment } from '@recruitee/i18n';
import { provideIntegrationsClientConfig } from '@recruitee/integrations-types';

// eslint-disable-next-line @nx/enforce-module-boundaries
// eslint-disable-next-line @nx/enforce-module-boundaries

// // @ts-ignore
import 'moment/locale/de';
import 'moment/locale/nl';
import 'moment/locale/fr';
import 'moment/locale/fi';
import 'moment/locale/sv';
import { AUTH_TOKEN_PLAYGROUND_LS_KEY } from './app/app.component';
import { environment } from './environments/environment';
patchMoment(moment);
moment().locale('en');

const xhrFactory: XhrFactory = { build: () => new XMLHttpRequest() };
const appConfig: IAppConfig = {
  apiUrl: environment.apiUrl,
  authUrl: environment.authUrl,
  webAppUrl: environment.webAppUrl,
  appUrl: environment.appUrl,
  hasHttps: true,
  isE2e: !!window.Cypress,
};

const localStorageAuthToken = () => localStorage.getItem(AUTH_TOKEN_PLAYGROUND_LS_KEY);

class PlaygroundAuthStrategy extends RecruiteeAuthStrategy {
  public onAuthorizationFailed() {
    localStorage.removeItem(AUTH_TOKEN_PLAYGROUND_LS_KEY);
    super.onAuthorizationFailed();
  }
}

const providers: Providers[] = [
  { provide: APP_CONFIG, useValue: appConfig },
  {
    provide: LANGUAGE_CONFIG,
    useValue: <LanguageConfig>{
      defaultLanguage: 'en',
      languages: ['en', 'de', 'fr', 'nl'],
    },
  },
  {
    provide: ENVIRONMENT,
    useValue: <CommonEnvironment>{ environmentName: 'development', angularProdMode: false },
  },
  { provide: CookieService, useClass: CookieService },
  { provide: AuthHelpers, useClass: AuthHelpers },
  { provide: AuthorisationStrategy, useClass: PlaygroundAuthStrategy },
  { provide: AuthService, useClass: AuthService },
  { provide: WebAppBootstrap, useClass: WebAppBootstrap },
  { provide: GenericAuthService, useClass: GenericAuthService },
  { provide: HttpClient },
  { provide: HttpXhrBackend },
  { provide: XhrFactory, useValue: xhrFactory },
  { provide: HttpHandler, useExisting: HttpBackend },
  { provide: HttpBackend, useExisting: HttpXhrBackend },
  provideIntegrationsClientConfig({
    environmentName: 'staging',
    apiUrl: appConfig.apiUrl,
    integrationsUrl: '',
    hasCheckrTestQueryParam: true,
    isE2e: !!window.Cypress,
  }),
  {
    provide: AUTH_TOKEN,
    useFactory: localStorageAuthToken,
  },
  { provide: GenericAuthService, useClass: GenericAuthService },
];

const injector = Injector.create({
  name: 'WebApp bootstrap injector',
  providers,
});

injector.get(WebAppBootstrap).bootstrap(
  providers,
  import('./app/app.module').then(m => m.AppModule),
);
